import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { CommonModule } from "@angular/common";
import { StoreModule, META_REDUCERS } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FormsModule } from '@angular/forms';

import { DynamicUiRoutingModule } from './dynamic-ui-routing.module';
import { DYNAMIC_FEATURE_KEY } from './store/dynamic.state';
import { DynamicEffects } from './store/dynamic.effects';
import { dynamicReducer } from './store/dynamic.reducer';
import { DynamicFacade } from './store/dynamic.facade';
import { dynamicMetaReducer, subscriptionMetaReducerFactory } from './store/dynamic.metareducer';
import { SubscriptionManagerService } from './store/subscription-manager.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
// Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatTreeModule } from "@angular/material/tree";
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

// Dynamic Controls
import { RowComponent } from './controls/row/row.component';
import { ColumnComponent } from './controls/column/column.component';
import { LabelComponent } from './controls/label/label.component'
import { LabelWithTitleComponent } from './controls/label-with-title/label-with-title.component'
import { TabComponent } from './controls/tab/tab.component'
import { LinkComponent } from './controls/link/link.component'
import { InputComponent } from './controls/input/input.component'
import { ImageComponent } from './controls/image/image.component'
import { TargetComponent } from './controls/target/target.component'
import { FileSelectorComponent } from './controls/file-selector/file-selector.component'
import { DropDownComponent } from './controls/drop-down/drop-down.component'
import { TableComponent } from './controls/table/table.component'
import { TreeComponent } from './controls/tree/tree.component'
import { ButtonComponent } from './controls/button/button.component'
import { SubmitButtonComponent } from './controls/submit-button/submit-button.component'
import { CardComponent } from './controls/card/card.component'
import { GridComponent } from './controls/grid/grid.component'
import { GridItemComponent } from './controls/grid-item/grid-item.component'
import { TitleComponent } from './controls/title/title.component'
import { ExpansionPanelComponent } from './controls/expansion-panel/expansion-panel.component'
import { AccordionComponent } from './controls/accordion/accordion.component'
import { DividerComponent } from './controls/divider/divider.component'
import { FormComponent } from './controls/form/form.component'
import { CheckboxComponent } from './controls/checkbox/checkbox.component'
import { PdfViewerComponent } from './controls/pdf-viewer/pdf-viewer.component'
import { UiDefinitionComponent } from './controls/ui-definition/ui-definition.component'
import { ObjectToJsonPipe } from 'src/app/shared/pipes/object-to-json.pipe';

// Shared components
import { getLocaleDateFormat } from 'src/app/shared/helpers/date-time-helper';

@NgModule({
  declarations: [
    // Controls
    RowComponent,
    ColumnComponent,
    LabelComponent,
    LabelWithTitleComponent,
    TabComponent,
    LinkComponent,
    InputComponent,
    ImageComponent,
    TargetComponent,
    FileSelectorComponent,
    DropDownComponent,
    TableComponent,
    TreeComponent,
    ButtonComponent,
    CardComponent,
    GridComponent,
    GridItemComponent,
    TitleComponent,
    ExpansionPanelComponent,
    AccordionComponent,
    DividerComponent,
    FormComponent,
    CheckboxComponent,
    SubmitButtonComponent,
    PdfViewerComponent,
    UiDefinitionComponent,
    // Pipes
    ObjectToJsonPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    DynamicUiRoutingModule,
    FormsModule,
    // Material
    MatFormFieldModule,
    MatTabsModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatTableModule,
    MatTreeModule,
    MatSortModule,
    DragDropModule,
    MatDividerModule,
    MatIconModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    // ngrx
    StoreModule.forFeature(DYNAMIC_FEATURE_KEY, dynamicReducer, { metaReducers: [dynamicMetaReducer] }),
    EffectsModule.forFeature(DynamicEffects),
  ],
  exports: [
    RowComponent,
    ColumnComponent,
    LabelComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: navigator.language },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: getLocaleDateFormat(navigator.language) },
    DynamicFacade,
    provideAnimations(),
    {
      provide: META_REDUCERS,
      useFactory: subscriptionMetaReducerFactory,
      deps: [SubscriptionManagerService],
      multi: true
    }
  ],    
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class DynamicUiModule { }